export const DEFAULT_STICKERS = [
	'/static/photobooth/msj/stickers/blitz.svg',
	'/static/photobooth/msj/stickers/chapeau.svg',
	'/static/photobooth/msj/stickers/lunette.svg',
	'/static/photobooth/msj/stickers/festif.svg',
	'/static/photobooth/msj/stickers/fou-rire.svg',
	'/static/photobooth/msj/stickers/soulager.svg',
	'/static/photobooth/msj/stickers/surpris-gener.svg',
	'/static/photobooth/msj/stickers/yeux-coeur.svg',
	'/static/photobooth/msj/stickers/yeux-etoiles.svg',
];

export const RUNTIME_CACHE = "runtime-v2";
export const PRECACHE = 'precache-v3'
export const IMAGE_CACHE = 'image-v3'
export const STATIC_ASSETS = 'static-assets-v2'
